import { render, staticRenderFns } from "./RXSubscriptionForm.vue?vue&type=template&id=c299815a&scoped=true"
import script from "./RXSubscriptionForm.vue?vue&type=script&lang=ts"
export * from "./RXSubscriptionForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c299815a",
  null
  
)

export default component.exports